import SearchIcon from '@mui/icons-material/Search'
import { Box, InputAdornment, TextField, Typography } from '@mui/material'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import CircularProgress from '@mui/material/CircularProgress'
import Grid from '@mui/material/Grid2'
import { useAtomValue } from 'jotai'
import React from 'react'
import { useNavigate } from 'react-router'

import UserCard from '../components/cards/UserCard'
import { useUsers } from '../contexts/UserContext'
import { usersAtom } from '../domains/user/AtomUsers'

export default function Users() {
  const { fetchUsersLoading, fetchUsersError, initUsers } = useUsers()
  // const { users, fetchUsersLoading, fetchUsersError, initUsers } = useUsers()
  const users = useAtomValue(usersAtom)
  const navigate = useNavigate()
  const [searchQuery, setSearchQuery] = React.useState('')

  React.useEffect(() => {
    initUsers()
  }, [initUsers])

  const filteredUsers = React.useMemo(() => {
    if (!searchQuery) return Object.values(users)
    const query = searchQuery.toLowerCase()
    return Object.values(users).filter(
      (user) =>
        user.name.toLowerCase().includes(query) ||
        user.email.toLowerCase().includes(query) ||
        (user.sports && user.sports.some((sport) => sport.toLowerCase().includes(query))) ||
        (user.certificates && user.certificates.some((cert) => cert.toLowerCase().includes(query))),
    )
  }, [users, searchQuery])

  if (fetchUsersLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress />
      </Box>
    )
  }

  if (fetchUsersError) {
    return (
      <Box sx={{ p: 2 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {fetchUsersError}
        </Alert>
        <Button variant="contained" onClick={() => navigate(-1)}>
          Go Back
        </Button>
      </Box>
    )
  }

  return (
    <Box sx={{ p: 2 }}>
      <Typography variant="h4" gutterBottom>
        Users Directory
      </Typography>

      <Box sx={{ mb: 3 }}>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Search by name, sports, or certifications..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Box>

      <Grid container spacing={2} justifyContent="center" alignItems="stretch">
        {filteredUsers.map((user) => (
          <Grid size={{ xs: 'auto' }} key={user.value}>
            <UserCard user={user} size="medium" />
          </Grid>
        ))}
        {filteredUsers.length === 0 && (
          <Box sx={{ p: 3, textAlign: 'center', width: '100%' }}>
            <Typography variant="body1" color="text.secondary">
              No users found matching your search criteria.
            </Typography>
          </Box>
        )}
      </Grid>
    </Box>
  )
}
